import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('add_bills'),
    addButtonText: defineMessage('add_2'),
    list: defineMessage('list'),
    groupBySupplier: defineMessage('group_by_supplier'),
    totalAmountOfSelectedBills: defineMessage('total_amount_of_selected_bills'),
    dateFromCantBeAfterDateTo: defineMessage('the_from_date_must_be_earlier_than_the_to_date'),
};
